export const vehicleArray = [
  {
    vehicleType: "sedan",
    vehicleName: "SEDAN",
    available: "2",
    price: "-",
    orginalPrice: "20",
  },
  {
    vehicleType: "xl",
    vehicleName: "XL",
    available: "5",
    price: "-",
    orginalPrice: "70",
  },
  {
    vehicleType: "vipplus",
    vehicleName: "VIP PLUS",
    available: "1",
    price: "-",
    orginalPrice: "100",
  },
  {
    vehicleType: "vip",
    vehicleName: "VIP",
    available: "1",
    price: "-",
    orginalPrice: "90",
  },

  {
    vehicleType: "aeexpresspickup",
    vehicleName: "AE EXPRESS PICKUP",
    available: "1",
    price: "-",
    orginalPrice: "90",
  },
];

export const TaxiModelArray = [
  ["LEXUS ES 300H"],
  ["Toyota Highlander", "Toyota Previa", "Honda Odyssey", "KIA Carinival"],
  [
    "GMC Yukon XL",
    "Chevrolet Traverse",
    "Chevrolet Suburban",
    // 'Mercedes Viano',
    "VOLKSWAGON TERAMONT",
  ],
  [
    "Mercedes S-CLass",
    "Cadillac Escalae ESV",
    "Mercedes V-Class",
    "TESLA Model Y",
  ],
  ["Mercedes S-CLass", "TESLA Model Y"],
];

export function getDriverByModel(driverDetails, modelId) {
  let driverByModel = [];
  if (driverDetails) {
    for (let i = 0; i < driverDetails.length; i++) {
      if (driverDetails[i].taxi_model == modelId) {
        driverByModel.push(driverDetails[i]);
      }
    }
  }
  return driverByModel;
}